<main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">

  <div class="text-center">
    <p class="text-base font-semibold text-red-500">Close account</p>
    <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">You have successfully closed your account</h1>
    <p class="mx-auto max-w-7xl mt-6 text-base leading-7 text-gray-500">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </p>
    <div class="mt-10 flex items-center justify-center gap-x-6">
      <a href="https://www.salesommo.com" class="text-sm font-semibold text-gray-900">Home page <span aria-hidden="true">&rarr;</span></a>
    </div>
  </div>

</main>
